/**
 * Created by Andrey Popov on 2/3/26.
 */

RewardsConfig.NightPartyCheapPack = [
    { energy: 90, hard: 10 },
    { energy: 300, hard: 30 },
    { energy: 300, hard: 30 },
    { energy: 1000, hard: 100 },
    { energy: 1000, hard: 100 }
];

RewardsConfig.NightPartyExpPack = [
    { energy: 300, hard: 50 },
    { energy: 1000, hard: 150 },
    { energy: 1000, hard: 150 },
    { energy: 4000, hard: 2250 },
    { energy: 4000, hard: 2250 }
];